import { createContext } from "react";

import { BaseMultiProject, Maybe, Project, Version } from "fond/types";

export interface IEditorContextValue {
  // The source project selected in the Copy Styles feature to copy styles from
  copyStylesSourceProject: Maybe<Project | BaseMultiProject>;
  // The source version selected in the Copy Styles feature to copy styles from
  copyStylesSourceVersion: Maybe<Version>;
  // Sets the source project for the Copy Styles feature
  setCopyStylesSourceProject: (project: Maybe<Project | BaseMultiProject>) => void;
  // Sets the source version for the Copy Styles feature
  setCopyStylesSourceVersion: (version: Maybe<Version>) => void;
}

export const EditorContext = createContext<IEditorContextValue | undefined>(undefined);
